import { render, staticRenderFns } from "./load-search-dialog.vue?vue&type=template&id=8b09b8da&scoped=true&"
import script from "./load-search-dialog.vue?vue&type=script&lang=js&"
export * from "./load-search-dialog.vue?vue&type=script&lang=js&"
import style0 from "./load-search-dialog.vue?vue&type=style&index=0&id=8b09b8da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b09b8da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItem,VListItemContent,VListItemGroup})
